import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BsBuilding } from "react-icons/bs";
import { LuUsers } from "react-icons/lu";
import { IoAddSharp } from "react-icons/io5";
import Header from "../component/Header";
import { FiDollarSign, FiTrash2 } from "react-icons/fi";
import { API_BASE_URL } from "../utils/apiConfig";
import { FaRupeeSign } from "react-icons/fa";
import Swal from 'sweetalert2';
function UserPage() {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [todayRevenue, setTodayRevenue] = useState(0);
    const [loading, setLoading] = useState(true);
    const userRole = localStorage.getItem("role");
    const currentUserId = localStorage.getItem("user_id_PK");

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const token = localStorage.getItem("token");
                if (!token) {
                    navigate("/");
                    return;
                }
                const config = { headers: { Authorization: `Bearer ${token}` } };
                
                const usersRes = await axios.get(`${API_BASE_URL}/api/admins`, config);
                setUsers(usersRes.data);

                const revenueRes = await axios.get(`${API_BASE_URL}/api/orders/today-revenue`, config);
                if (revenueRes.data.status) {
                    setTodayRevenue(revenueRes.data.todayRevenue);
                }
            } catch (err) {
                console.error("Failed to fetch data", err);
            } finally {
                setLoading(false);
            }
        };
        fetchInitialData();
    }, [navigate]);

    const deleteUser = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to remove this user? This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#22c55e",
            cancelButtonColor: "#ef4444",
            confirmButtonText: "Yes, delete user!",
            background: '#1b1d1a',
            color: '#fff'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const token = localStorage.getItem("token");
                    await axios.delete(`${API_BASE_URL}/api/admins/${id}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    setUsers(users.filter(u => u.user_id_PK !== id));
                    Swal.fire({ icon: 'success', title: 'Deleted!', text: 'User has been removed.', background: '#1b1d1a', color: '#fff', confirmButtonColor: '#22c55e' });
                } catch (err) {
                    Swal.fire({ icon: 'error', title: 'Error', text: "Failed to delete user", background: '#1b1d1a', color: '#fff', confirmButtonColor: '#ef4444' });
                }
            }
        });
    };

    const filteredUsers = userRole === 'superadmin'
        ? users
        : users.filter(u => String(u.user_id_PK) === String(currentUserId));

    const adminCount = filteredUsers.filter(u => u.role === 'admin').length;
    const techCount = filteredUsers.filter(u => u.role === 'technician').length;

    if (loading) return <div className="bg-black min-h-screen text-white flex items-center justify-center">Loading User Accounts...</div>;

    return (
        <div className="bg-black min-h-screen text-white p-6">
            <Header />

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8 ">
                <div className="bg-[#1b1d1a] rounded-2xl p-6 border border-gray-700 shadow-lg hover:shadow-xl transition">
                    <div className="flex items-start gap-3">
                        <BsBuilding className="text-green-400 text-3xl mt-3" />
                        <div>
                            <p className="text-gray-400 text-sm">Total Device Partners</p>
                            <h2 className="text-green-400 text-3xl font-bold mt-1">{adminCount}</h2>
                        </div>
                    </div>
                </div>

                <div className="bg-[#1b1d1a] rounded-2xl p-6 border border-gray-700 shadow-lg hover:shadow-xl transition">
                    <div className="flex items-start gap-3">
                        <LuUsers className="text-blue-400 text-3xl mt-3" />
                        <div>
                            <p className="text-gray-400 text-sm">Active Technicians</p>
                            <h2 className="text-blue-400 text-3xl font-bold mt-1">{techCount}</h2>
                        </div>
                    </div>
                </div>

                <div className="bg-[#1b1d1a] rounded-2xl p-6 border border-gray-700 shadow-lg hover:shadow-xl transition">
                    <div className="flex items-start gap-3">
                        <FaRupeeSign  className="text-green-400 text-3xl mt-3" />
                        <div>
                            <p className="text-gray-400 text-sm">Today's Revenue</p>
                            <h2 className="text-green-400 text-3xl font-bold mt-1">₹{todayRevenue.toLocaleString()}</h2>
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 gap-6 mt-8">
                <div className="bg-[#1b1d1a] rounded-2xl p-6 border border-gray-700 shadow-lg">
                    <div className="flex items-center justify-between mb-4">
                        <h2 className="text-xl font-bold text-green-400">User List</h2>
                        {userRole === 'superadmin' && (
                            <button
                                onClick={() => navigate("/addUser")}
                                className="flex items-center gap-2 px-4 py-2 text-sm bg-green-400 font-semibold rounded-xl text-black hover:bg-green-500 transition shadow-lg shadow-green-900/20 active:scale-95"
                            >
                                <IoAddSharp /> Add New Account
                            </button>
                        )}
                    </div>

                    <div className="overflow-x-auto">
                        <table className="min-w-full text-sm text-gray-300">
                            <thead>
                                <tr className="border-b border-gray-700 text-gray-500 uppercase tracking-wider text-[11px]">
                                    <th className="px-4 py-3 text-left">Organization</th>
                                    <th className="px-4 py-3 text-left">Device Name</th>
                                    <th className="px-4 py-3 text-left">User Name</th>
                                    <th className="px-4 py-3 text-left">Email</th>
                                    <th className="px-4 py-3 text-left">Location</th>
                                    <th className="px-4 py-3 text-left">Role</th>
                                    <th className="px-4 py-3 text-left">Linked Device ID</th>
                                    <th className="px-4 py-3 text-right">Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredUsers.map((user) => (
                                    <tr key={user.user_id_PK} className="border-b border-gray-800 hover:bg-[#1e1e1e] transition">
                                        <td className="px-4 py-3">
                                            <p className="text-white font-semibold">{user.organization_name}</p>
                                            {/* <p className="text-[10px] text-gray-500">{user.name}</p> */}
                                        </td>
                                        <td className="px-4 py-3 text-gray-400">{user.device_name}</td>
                                        <td className="px-4 py-3 text-gray-400">{user.name}</td>
                                        <td className="px-4 py-3 text-gray-400">{user.email}</td>
                                        <td className="px-4 py-3 text-gray-400">{user.location}</td>
                                        <td className="px-4 py-3">
                                            <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase border ${user.role === 'admin' ? 'border-green-400 text-green-400' : 'border-blue-400 text-blue-400'
                                                }`}>
                                                {user.role}
                                            </span>
                                        </td>
                                        <td className="px-4 py-3">
                                            <span className="px-3 py-1 text-[11px] font-semibold rounded-full bg-gray-900 border border-gray-800 text-gray-400">
                                                ID: {user.device_id || 'unassigned'}
                                            </span>
                                        </td>
                                        <td className="px-4 py-3 text-right">
                                            {userRole === 'superadmin' && (
                                                <button
                                                    onClick={() => deleteUser(user.user_id_PK)}
                                                    className="p-2 text-gray-600 hover:text-red-500 hover:bg-red-500/10 rounded-lg transition"
                                                >
                                                    <FiTrash2 />
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserPage;
